module.exports = "<div class=\"cash-out-notification-wrapper\">\n    <equity-notification notification=\"notification\"></equity-notification>\n</div>";